// extracted by mini-css-extract-plugin
export default {"basicInfo":"basicInfo--ttQcq","card":"card--enGaY","markerAnimationScale":"markerAnimationScale--PyRFG"};